import React from 'react';
import MDICheckBold from 'src/assets/images/MDICheckBold.svg';
import { MDICheckBoldImg, SuccessMsg } from './CustomerCareNotes.styled';
import { useTranslation } from 'react-i18next';

const SuccessMsgContainer = ({
    className,
    marginRight,
    marginBottom

}) => {
        const { t } = useTranslation();
  return (
      <>
          <div
              className={className}
              style={{
                  marginRight: `${marginRight}`,
                  marginBottom: `${marginBottom}`,
              }}
          >
              <MDICheckBoldImg src={MDICheckBold} />
              <SuccessMsg mbMargin={'0 0 0 5px'} float={'left'}>
                  {t('more.common.notSucessfullyEdited')}
              </SuccessMsg>
          </div>
      </>
  );
};

export default SuccessMsgContainer;